import SEO from "@/components/SEO";
import { PageHero, CTABand, Reveal, PHONE, PHONE_LINK, EMAIL } from "@/components/Ui";
import DevisForm from "@/components/DevisForm";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const zones = ["Bernay", "Évreux", "Beuzeville", "Pont-Audemer", "Thiberville", "Deauville", "Menneval", "Serquigny", "Brionne", "Le Neubourg", "Louviers", "Vernon", "Rouen", "Toute l'Eure (27)"];

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact & devis gratuit | DMZ Normandie – Maçonnerie Bernay, Eure"
        description="Contactez DMZ Normandie pour un devis gratuit : maçonnerie, gros œuvre et rénovation à Bernay et dans l'Eure. Tél : 07 45 04 91 89."
        path="/contact"
      />
      <PageHero
        title="Contact & devis gratuit"
        subtitle="Un projet de construction, de rénovation ou d'aménagement ? Appelez-nous ou décrivez votre projet : nous vous répondons rapidement."
      />

      <section className="py-20 lg:py-28" data-testid="contact-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-5">
            <h2 className="font-serif-display font-light text-3xl md:text-4xl text-[#F5F5F0] mb-8">
              Parlons de votre <em className="text-accent-sand">projet</em>
            </h2>
            <p className="text-zinc-400 font-light leading-relaxed mb-8">
              Décrivez-nous votre projet en quelques lignes, ajoutez des photos si vous le souhaitez :
              nous vous recontactons afin d'échanger sur vos besoins et déterminer ensemble les
              prochaines étapes. Vous pouvez aussi nous appeler directement, à toute heure.
            </p>
            <p className="text-zinc-400 font-light leading-relaxed mb-8">
              Construction neuve, extension, rénovation de façade, dalle béton, ouverture de mur porteur
              ou simple réparation : chaque demande est étudiée avec attention. Après votre message, nous
              échangeons par téléphone, puis nous nous déplaçons gratuitement sur place — à Bernay, Évreux
              et dans toute l'Eure — pour voir le bâti ou le terrain avant de chiffrer. Le devis est
              gratuit, détaillé poste par poste, et sans engagement.
            </p>
            <div className="space-y-5 mb-10" data-testid="contact-infos">
              <a href={PHONE_LINK} className="flex items-center gap-4 group" data-testid="contact-phone">
                <span className="w-11 h-11 bg-[#C4A484] text-[#0A0A0A] rounded-full flex items-center justify-center shrink-0"><Phone size={17} /></span>
                <span>
                  <span className="block text-[10px] uppercase tracking-[0.25em] text-zinc-600">Téléphone</span>
                  <span className="text-base font-medium text-[#F5F5F0] group-hover:text-[#C4A484] transition-colors">{PHONE}</span>
                </span>
              </a>
              <a href={`mailto:${EMAIL}`} className="flex items-center gap-4 group" data-testid="contact-email">
                <span className="w-11 h-11 border border-white/15 rounded-full text-[#C4A484] flex items-center justify-center shrink-0"><Mail size={17} /></span>
                <span>
                  <span className="block text-[10px] uppercase tracking-[0.25em] text-zinc-600">E-mail</span>
                  <span className="text-base font-medium text-[#F5F5F0] group-hover:text-[#C4A484] transition-colors">{EMAIL}</span>
                </span>
              </a>
              <p className="flex items-center gap-4">
                <span className="w-11 h-11 border border-white/15 rounded-full text-[#C4A484] flex items-center justify-center shrink-0"><MapPin size={17} /></span>
                <span className="text-sm font-light text-zinc-400">7 rue Jean de la Fontaine, 27000 Évreux</span>
              </p>
              <p className="flex items-center gap-4">
                <span className="w-11 h-11 border border-white/15 rounded-full text-[#C4A484] flex items-center justify-center shrink-0"><Clock size={17} /></span>
                <span className="text-sm font-light text-zinc-400">Joignable 24 h/24 — 7 j/7</span>
              </p>
            </div>

            <p className="text-[10px] tracking-[0.4em] uppercase text-[#C4A484] mb-4">Zone d'intervention</p>
            <div className="flex flex-wrap gap-2" data-testid="zone-intervention">
              {zones.map((z) => (
                <span key={z} className="border border-white/10 px-4 py-2 text-xs font-light tracking-wider text-zinc-400 hover:border-[#C4A484] hover:text-[#C4A484] transition-colors duration-300">{z}</span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <DevisForm />
          </Reveal>
        </div>
      </section>

      <CTABand />
    </>
  );
}
